import { BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'pages/Header/Content/functions/storageBase64';

export default async function getTelmexStatus(data) {

    console.log("getTelmexStatus:",data);
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/sol-claro/solicitudes-claro/v1/telmex?externalId=${data.externalId}&telefono=${data.numero}`
    }else{
        apiURL = `${BASE_PATH_API}/sol-claro/solicitudes-claro/v1/telmex?externalId=${data.externalId}&telefono=${data.numero}`
    }

    const access_token = decodeStorage('access_token');

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${access_token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            // console.log(error)
            // console.log(error.request)
            // console.log(error.response)
            // console.log(error.response.data)
            return (
                {
                    'headers': '',
                    'statusCode': error?.request?.status,
                    'data': error?.response?.data,
                    'error': error?.response?.data?.codMen

                })
        })
}
